import React from 'react'
import { IconButton, minorScale } from 'evergreen-ui'
import { IconBadge } from 'evergreen-draft'

interface NotificationsToggleProps {
  unreadCount: number
}

class NotificationsToggle extends React.Component<NotificationsToggleProps> {
  render() {
    const { unreadCount, ...props } = this.props

    return (
      <IconBadge count={unreadCount} cursor="pointer" paddingX={0} badgeStyle={{ top: 5, right: 5, zIndex: 5 }}>
        <IconButton icon="notifications" appearance="minimal" iconSize={minorScale(5)} {...props} />
      </IconBadge>
    )
  }
}

export default NotificationsToggle
